@if (linksList && !!linksList.length) {
  <div class="interlinks">
    <h2 class="interlinks__title" i18n="@@interlinking_more_hotels">Otros alojamientos a buenos precios</h2>
    <div class="interlinks__links-container">
      @for (link of linksList; track link) {
        <a target="_blank" href="{{link.url}}" class="interlinks__links-container__link">
          <mb-icon-text>
            <mb-icon icon="hotels"></mb-icon>
            <span>{{link.cityName}}</span>
          </mb-icon-text>
        </a>
      }
    </div>
  </div>
}